import { Component, Output, EventEmitter, Input, ViewEncapsulation } from '@angular/core';
import { DisplayFadeInOutAnimation, NHADisplayFadeInOutAnimationDirective } from '../animations/display-fade-in-out.animation';

import { MatIconModule } from '@angular/material/icon';
import { NHATestDirective } from '../../directives/test/test.directive';
import { MatButtonModule } from '@angular/material/button';
import { singularize } from '@nha/functions';

@Component({
	selector: 'nha-action-bar',
	templateUrl: './action-bar.component.html',
	styleUrls: ['./action-bar.component.scss'],
	animations: [DisplayFadeInOutAnimation.animation],
	encapsulation: ViewEncapsulation.None,
	imports: [NHADisplayFadeInOutAnimationDirective, MatButtonModule, NHATestDirective, MatIconModule]
})
export class NHAActionBarComponent {
	@Input() recordType: string = '';
	@Input() selectedCount: number;
	@Input() isActionBarOpen: boolean;
	@Output() closed = new EventEmitter<void>();

	get displayRecordType(): string {
		if (!this.recordType) {
			return '';
		}
		return this.selectedCount === 1 ? singularize(this.recordType) : this.recordType;
	}
}
